import { graphql } from 'react-relay/legacy.js';

export const PhotosSearchBrowseQuery = graphql`
    query PhotosSearchBrowseQuery(
        $page: Int
        $first: Int
        $searchTerm: String
        $style: [String!]
        $room: [String!]
        $project: [String!]
        $creator: [String!]
    ) {
        viewer {
            photosSearchBrowseQuery(
                page: $page
                first: $first
                searchTerm: $searchTerm
                style: $style
                room: $room
                project: $project
                creator: $creator
            ) {
                totalResults
                edges {
                    node {
                        path
                    }
                }
            }
            ...PhotosSearchBrowseWrapper_viewer
        }
    }
`;
